import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";
import BackToTop from "@/components/feature/BackToTop";
import BreakingTicker from "./components/BreakingTicker";
import HomeMasthead from "./components/HomeMasthead";
import HeroSection from "./components/HeroSection";
import CategoryExplorer from "./components/CategoryExplorer";
import DeepDiveSection from "./components/DeepDiveSection";
import RankingSection from "./components/RankingSection";
import TrustSection from "./components/TrustSection";
import FaqSection from "./components/FaqSection";
import NewsletterSection from "./components/NewsletterSection";
import { faqItems, siteName, siteTagline } from "@/mocks/site";
import { hotArticles } from "@/mocks/articles";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: siteName,
        description:
          "黑料八卦网专注圈内秘闻与深扒，提供黑料八卦爆料、内幕、猛料与起底内容。",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://billionan.cn/?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "Organization",
        name: siteName,
        description: siteTagline,
        email: "qunnei@heiliaobagua.example.com",
      },
      {
        "@type": "FAQPage",
        mainEntity: faqItems.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
      {
        "@type": "ItemList",
        name: "爆料热榜",
        itemListElement: hotArticles.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `https://billionan.cn/article/${item.id}`,
          name: item.title,
        })),
      },
    ],
  };

  return (
    <>
      <title>黑料八卦网 | 圈内秘闻爆料 内幕猛料深扒起底持续更新</title>
      <meta
        name="description"
        content="黑料八卦网专注圈内秘闻与深扒，提供黑料八卦爆料、内幕、猛料与起底内容。不追表面热点，直接梳理事件脉络与证据链，吃瓜也要吃得明白，内容持续更新。"
      />
      <meta
        name="keywords"
        content="黑料八卦,黑料八卦爆料,黑料八卦秘闻,黑料八卦内幕,黑料八卦猛料,黑料八卦深扒,黑料八卦起底"
      />
      <link rel="canonical" href="https://billionan.cn/" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      <SiteHeader />
      <main>
        <HomeMasthead />
        <BreakingTicker />
        <HeroSection />
        <CategoryExplorer />
        <DeepDiveSection />
        <RankingSection />
        <TrustSection />
        <FaqSection />
        <NewsletterSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}